"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basic = void 0;
exports.basic = `
varying vec2 vUv;

out mat4 viewMatrixInverse;

void main() {
    viewMatrixInverse = inverse(viewMatrix);
    vUv = position.xy * 0.5 + 0.5;
    gl_Position = vec4(position.xy, 1.0, 1.0);
}
`;
//# sourceMappingURL=basic.js.map